import Logger from "@/helpers/logger";
import entriApi from "./entri.api";
import { getEntriConfig } from "@/helpers/entriConfig";
import store from "@/store";

class EntriService {
  getEntriToken() {
    try {
      return entriApi.getEntriToken();
    } catch (e) {
      Logger.error("`getEntriToken` service", e);
      return Promise.reject(e);
    }
  }

  async checkDomain(domain, records) {
    try {
      store.dispatch("entri/isFetching", true);
      const data = await entriApi.getEntriToken();
      if (!data?.auth_token) {
        throw new Error("EntriApi token is missing");
      }
      const config = getEntriConfig(data.auth_token, records);
      const response = await entriApi.checkDomain(domain, config);
      store.dispatch("entri/setupResponse", response);
      return response;
    } catch (e) {
      Logger.error("`checkDomain` service", e);
      return Promise.reject(e);
    } finally {
      store.dispatch("entri/isFetching", false);
    }
  }
}

const entriService = new EntriService();

export default entriService;
